(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name com.module.core.directive:register
   * @description
   * # register
   */
  angular
    .module('com.module.users')
    .directive('register', function () {
      return {
        templateUrl: 'app/modules/users/views/register.html',
        restrict: 'E'
      };
    });

})();
